var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"padless":"","fixed":"","app":""}},[_c('v-card',{attrs:{"flat":"","tile":"","width":"100%"}},[_c('v-card-text',{class:[
            'py-3 app-bar agreements d-flex justify-center',
            { 'flex-column align-center': _vm.$vuetify.breakpoint.xsOnly },
            ]},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.copyright)}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }